<template>
  <div>
    <div class="tree-head">
      <span>城市列表</span>
      <el-input
        size="mini"
        class="search"
        clearable
        placeholder="输入名称"
        v-model="text"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="search"
        ></el-button>
      </el-input>
    </div>
    <div class="citys-tree m-scroll" :style="'height: ' + height">
      <el-tree
        ref="tree"
        :data="data"
        :props="treeProps"
        node-key="DistrictId"
        :expand-on-click-node="false"
        :filter-node-method="filterNode"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
          <span class="btn-box" @click="onSelect(data)">
            <el-button
              class="btn"
              :disabled="data.check"
              icon="el-icon-right"
            ></el-button>
          </span>
        </span>
      </el-tree>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    height: {
      type: String,
      default: "300px",
    },
    Lvs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      data: [],
      source: [],
      text: "",
      api: require("@/api/sale/district").default,
      treeProps: {
        children: "children",
        label: "Name",
      },
    };
  },
  methods: {
    init(data = {}) {
      var notIds = [];
      if (data.filterIds);
      {
        notIds = data.filterIds;
      }
      console.log(notIds, "notids");

      this.text = "";
      this.api.list({ Lvs: this.Lvs }).then((res) => {
        res.Data = res.Data.filter((x) => x.Lv == 1 || x.Lv == 2);
        this.source = res.Data.map((x) => {
          if (x.Name == "汕头市") {
            console.log("?!", x);
          }
          var check = false;
          if (notIds)
            check = notIds.some((c) => c == x.DistrictId || c == x.Pid);
          return { ...x, check: check };
        });
        if (data) {
          if (data.Counts) {
            if (data.Counts.length > 0) {
              this.source.forEach((x) => {
                data.Counts.forEach((item) => {
                  if (x.DistrictId == item.DistrictId) {
                    x.check = true;
                  }
                });
              });
            }
          }
          if (data.Weights) {
            if (data.Weights.length > 0) {
              this.source.forEach((x) => {
                data.Weights.forEach((item) => {
                  if (x.DistrictId == item.DistrictId) {
                    x.check = true;
                  }
                });
              });
            }
          }
        }

        this.data = this.$commonJs.toTreeData(this.source, "DistrictId");
      });
    },
    search() {
      this.$refs.tree.filter(this.text);
    },
    filterNode(value, data) {
      if (!value) return true;
      var result1 = data.NameChain.indexOf(value) !== -1;
      // var result2 = data.CityName.indexOf(value) !== -1;
      // var result3 = data.ProvinceName.indexOf(value) !== -1;
      return result1;
    },
    onSelect(data) {
      if (!data.check) {
        this.$emit("select", data);
        data.check = true;
        // if (data.children) {
        //   data.children.forEach((x) => {
        //     x.check = true;
        //   });
        // }
      }
    },
    remove(id) {
      //
      var node = this.$refs.tree.getNode(id);
      node.data.check = false;
      // if (node.data.children) {
      //   node.data.children.forEach((x) => {
      //     x.check = false;
      //   });
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.tree-head {
  width: 100%;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;
  padding-left: 10px;
  border: 1px solid #ebeef5;
  border-bottom: none;
  .search {
    width: 250px;
    float: right;
    margin-top: 6px;
    margin-right: 5px;
  }
}
.citys-tree {
  overflow-y: auto;
  border: 1px solid #ebeef5;
}

.custom-tree-node {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  width: 100%;
  .btn-box {
    float: right;
    margin-right: 10px;
    .btn {
      font-size: 22px;
      width: 50px;
      padding: 0 !important;
      height: 24px;
      text-align: center;
      transform: translateY(4px);
    }
  }
}
</style>